module.exports = __webpack_public_path__ + "img/item-1-img.d5713f36.png";